import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["option", "input", "customFields", "customSubmit", "form"]

  connect() {
    this.initializeState()
    this.setupEventListeners()
  }

  get formElement() {
    // If the controller is attached to a form element, use it directly
    if (this.element.tagName === 'FORM') {
      return this.element
    }
    // If we have a form target, use it
    if (this.hasFormTarget) {
      return this.formTarget
    }
    // Otherwise, find the form within the element
    return this.element.querySelector('form')
  }

  initializeState() {
    // Always ensure the input has a value, either from server params or default
    const serverValue = this.inputTarget.value
    const defaultValue = this.getDefaultValue()

    if (!serverValue) {
      this.inputTarget.value = defaultValue
    }

    const currentValue = this.inputTarget.value
    this.setCustomFieldsVisibility(currentValue)
    this.updateActiveOption(currentValue)

    // Ensure the form always has the current value in the hidden field
    // This is important for the test to work correctly
    if (this.inputTarget.value && !this.inputTarget.value.trim()) {
      this.inputTarget.value = currentValue || defaultValue
    }
  }

  getDefaultValue() {
    // Check if '14' option exists (source links page), otherwise use '7' (projects page)
    const fourteenDaysOption = this.optionTargets.find(option => option.dataset.value === '14')
    return fourteenDaysOption ? '14' : '7'
  }

  setupEventListeners() {
    this.optionTargets.forEach(option => {
      option.addEventListener('click', () => this.handleOptionClick(option))
    })

    const form = this.formElement
    if (form) {
      form.addEventListener('submit', (e) => this.handleSubmit(e))
    }
  }

  handleOptionClick(option) {
    const value = option.dataset.value
    this.inputTarget.value = value
    this.updateActiveOption(value)
    this.setCustomFieldsVisibility(value)

    if (value !== 'custom') {
      // Always submit the form, even if clicking the same option
      // This ensures the URL parameter is set correctly
      const form = this.formElement
      if (form) {
        form.submit()
      }
    }
  }

  handleSubmit(e) {
    if (this.inputTarget.value === 'custom') {
      const start = this.formElement.querySelector('[name="start_date"]').value
      const end = this.formElement.querySelector('[name="end_date"]').value
      if (!start || !end) {
        e.preventDefault()
        alert('Please select both start and end dates.')
      }
    }
  }

  setCustomFieldsVisibility(value) {
    if (value === 'custom') {
      this.customFieldsTarget.style.display = 'flex'
      this.customSubmitTarget.style.display = 'inline-block'
    } else {
      this.customFieldsTarget.style.display = 'none'
      this.customSubmitTarget.style.display = 'none'
    }
  }

  updateActiveOption(value) {
    this.optionTargets.forEach(option => {
      if (option.dataset.value === value) {
        option.classList.add('bg-indigo-100', 'border-indigo-500')
      } else {
        option.classList.remove('bg-indigo-100', 'border-indigo-500')
      }
    })
  }
}
